import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControlKeyLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconControlKeyLeft"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 10L9 7.5L11.5 10" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconControlKeyLeft;
